import React from "react";
import "../home.css";
import { useNavigate } from "react-router-dom";
import MainNavbar from "./MainNavbar";
import logo from "../Image/Logo1.png";
import { Link } from "react-router-dom";
export default function Header() {
  const navigate = useNavigate();

  return (
    <header className="header-container">
      <div className="header-wrapper">
        <Link to="/">
          <div className="logo-box">
            <img src={logo} alt="Logo" className="logo-img " />
          </div>
        </Link>

        <MainNavbar />

        {/* <div className="right-section">
          <button
            className="get-started-btn"
            onClick={() => navigate("/register")}
          >
            Get Register
          </button>
        </div> */}
      </div>
    </header>
  );
}
